var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6162 48.7903L49.6176 48.7882C50.5031 47.4624 51.8647 46.5281 53.4203 46.1789C54.976 45.8297 56.6063 46.0924 57.9736 46.9125L57.9778 46.9151L68.5431 53.2174C68.5438 53.2179 68.5445 53.2183 68.5453 53.2188C69.2534 53.6433 69.8128 54.2766 70.1467 55.0317C70.4809 55.7876 70.5728 56.6285 70.4097 57.4388L70.4075 57.4501C69.985 59.6135 69.123 61.6671 67.8749 63.484C66.6267 65.3008 65.0189 66.8421 63.1511 68.0125C61.2833 69.1829 59.1951 69.9575 57.0158 70.2883C54.8395 70.6187 52.6185 70.4995 50.49 69.9381C39.1443 66.8291 28.8033 60.82 20.4845 52.5018C12.1656 44.1836 6.15559 33.8431 3.04564 22.4975C2.4836 20.3695 2.36372 18.1488 2.69345 15.9726C3.02361 13.7936 3.7975 11.7056 4.96723 9.83778C6.13695 7.96995 7.67761 6.3621 9.49383 5.11375C11.2584 3.90091 13.2465 3.0525 15.3418 2.61746H15.4052L15.6002 2.5783C16.4143 2.41481 17.2591 2.50873 18.0174 2.84704C18.7758 3.18535 19.41 3.75127 19.8322 4.4663L19.8327 4.4672L26.0727 15.0232L26.0731 15.0239C26.8822 16.3912 27.1358 18.0168 26.7818 19.5656C26.4278 21.1143 25.4932 22.4683 24.1705 23.3484L24.1688 23.3495L17.5408 27.7695L16.1702 28.6835L16.8047 30.2038C21.6986 41.9287 31.0065 51.2591 42.7196 56.1813L44.2391 56.8198L45.1562 55.4503L49.6162 48.7903Z",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/Availability.71b86894e7bbb7d3b9f5f08c55362c5c.svg";
export { ForwardRef as ReactComponent };